import React from "react";
import { Outlet } from "react-router-dom";

const AccountingParentPage = () => {
    return <Outlet />;
};

export default AccountingParentPage;
